import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { Link, useNavigate } from "react-router-dom";

function Otp(props) {
  const [storedMobileNumber, setStoredMobileNumber] = useState("");
  const [otpcode, setOtpcode] = useState();
  const [verifyDisabled, setVerifyDisabled] = useState(false);
  const [disableResend, setDisableResend] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let mobileNum = props?.$store?.mobileNumber;
    setStoredMobileNumber(mobileNum);
    setDisableResend(true);
  }, []);

  const handleChange = (otp) => {
    // console.log("otp changed: ", otp.length);
    setOtpcode(otp);
    if (otp.length === 6) {
      setOtpcode(otp);
      setVerifyDisabled(false);
    } else {
      setOtpcode(otp);
      setVerifyDisabled(true);
    }
  };

  // -------------------- OTP COUNTDOWN TIMER --------------------
  const timercount = 60;
  const initialTime = localStorage.getItem("countdown") || timercount;
  const [time, setTime] = useState(parseInt(initialTime, 10));
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    let countdownInterval;

    if (isRunning) {
      countdownInterval = setInterval(() => {
        if (time > 0) {
          setTime((prevTime) => prevTime - 1);
        } else {
          clearInterval(countdownInterval);
          let timerBox = document.getElementById("otpTimer");
          timerBox.innerText = "OTP expired";
          setIsRunning(false);
          setDisableResend(false);
          localStorage.removeItem("countdown");
        }
      }, 1000);
    }

    return () => clearInterval(countdownInterval);
  }, [isRunning, time]);

  useEffect(() => {
    localStorage.setItem("countdown", time.toString());
  }, [time]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("countdown");
    };
  }, []);

  const handleRestart = () => {
    setTime(timercount);
    setIsRunning(true);
    setDisableResend(true);
  };

  const handlePausePlay = () => {
    setIsRunning(!isRunning);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const handleResendOtp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log({ storedMobileNumber });
    let data = {
      mobile: storedMobileNumber,
    };

    props.apis
      .apiOTPLogin(data)
      .then((res) => {
        console.log({ apiOTPLogin: res });
        props.store("OTPresponses", res);
        props.store("mobileNumber", storedMobileNumber);
        handleRestart();
      })
      .catch((err) => {
        console.log({ OTPlogin: err });
      });
  };

  const handleOTPverify = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("OTPresponses", otpStoreValues);

    let storedMobileNumber = props?.$store?.mobileNumber;

    let data = {
      otp: otpcode,
      mobile: storedMobileNumber,
    };
    props.apis.apiOTPLoginVerify(data).then((res) => {
      console.log({ handleOTPverify: res });
      props.setstore("logged", res.logged);
      props.setstore("auth", res.auth);
      props.setstore("user", res.user);
      props.store("persona", res?.user?.role);

      let loginpath;
      if (
        res?.user?.role === _enum.PERSONAS.admin ||
        res?.user?.role === _enum.PERSONAS.collections ||
        res?.user?.role === _enum.PERSONAS.sales_lead
      ) {
        loginpath = "/app/home";
      } else if (
        res?.user?.role === _enum.PERSONAS.sales ||
        res?.user?.role === _enum.PERSONAS.ops
      ) {
        loginpath = "/app/leads";
      } else if (
        res?.user?.role === _enum.PERSONAS.underwriter ||
        res?.user?.role === _enum.PERSONAS.senior_underwriter
      ) {
        loginpath = "/app/pendingapplications";
      } else if (res?.user?.role === _enum.PERSONAS.it) {
        loginpath = "/app/audittrail";
      } else {
        if (res?.user?.status === "COMPLETED") {
          loginpath = "/app/customerhome";
        } else {
          loginpath = "/app/myprofile";
        }
      }
      navigate(loginpath);
    });
  };

  props.$setNode({
    props,
  });
  return (
    <>
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div
            className="bg-img-fix overflow-hidden"
            style={{ backgroundImage: "url(" + imagepaths.loginBg + ")" }}
          >
            <div className="parent-container row gx-0">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <div className="logo_header pt-5 ps-5">
                  <Link to={"/open/login"} className="logo">
                    <img src={imagepaths.loginWhiteBg} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                <div className="login-form style-2 py-4">
                  <div className="card-body">
                    <nav className="nav nav-tabs border-bottom-0">
                      <div className="tab-content w-100" id="nav-tabContent">
                        <div className="tab-pane active show fade">
                          {props.errorMessage && (
                            <div className="">{props.errorMessage}</div>
                          )}
                          {props.successMessage && (
                            <div className="">{props.successMessage}</div>
                          )}
                          <h3 className="form-title m-t0 text-center">
                            Enter OTP
                          </h3>
                          <div className="dz-separator-outer m-b5">
                            <div className="dz-separator bg-primary style-liner"></div>
                          </div>
                          <p className="sub-title text-center">
                            Access to explore more
                          </p>
                          <form className="dz-form py-2">
                            <span className="d-block text-center mx-auto mt-3 mb-0 otp_top_text">
                              OTP to verify
                            </span>
                            <OTPInput
                              value={otpcode}
                              onChange={(...args) => handleChange(...args)}
                              numInputs={6}
                              separator={<span>-</span>}
                              renderInput={(props) => <input {...props} />}
                              containerStyle="otp_container"
                            />

                            <div className="otp_timer_box d-flex flex-column justify-content-center mb-5">
                              {/* OTP COUNTDOWN TIMER */}
                              <p className="countdown_timer_box text-center">
                                <span className="me-1">Resend OTP in:</span>
                                <span className="mb-0 otp_timer" id="otpTimer">
                                  {formatTime(time)}
                                </span>
                              </p>
                            </div>

                            <div className="form-group clearfix text-left mb-4">
                              <button
                                type="submit"
                                className="btn btn-primary button-md btn-block"
                                onClick={(e) => handleOTPverify(e)}
                                disabled={verifyDisabled}
                              >
                                Verify
                              </button>
                            </div>
                          </form>
                        </div>
                        <div className="text-center otp_bottom">
                          <span className="me-2">Not received OTP?</span>
                          <button
                            type="button"
                            className={Object.className({
                              "plain-text-btn": true,
                              // "text-muted": disableResend,
                            })}
                            disabled={disableResend}
                            onClick={(...args) => handleResendOtp(...args)}
                          >
                            Resend
                          </button>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default constore(Otp);
